import React from 'react'
import Hero from './Hero/Hero'
import Marquee from '../../components/Marquee/Marquee'
import Projects from './Projects/Projects'
import Certifications from './Certifications/Certifications'
import Marquee2 from '../../components/Marquee2/Marquee2'
import useTitlePage from '../../hooks/useTitlePage'

const Home = () => {
  useTitlePage("Home | Allison Griffin")


  return (
    <div style={{width:"100%"}}>
      
        <Hero></Hero>
        <Marquee></Marquee>
        <Projects></Projects>
        <Marquee2></Marquee2>
        <Certifications></Certifications>
       

    </div>
  )
}

export default Home